import WechatPay from './WechatPay';

export default WechatPay;
